import { fromJS } from 'immutable';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { Tab, Tabs } from 'foundations-components/transitional/components/Tabs';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import LessonOverview from './LessonOverview';
import ResourcesList from './ResourcesList';
import ProfessorList from './ProfessorList';
import UsageTracker from '../../utils/UsageTracker';
import { useLessonContentById } from '../../features/lessons';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LessonInfoTabs = ({
  contentId,
  lesson,
  fullLesson,
  onResourceClick,
  trackId,
  isTracks = false
}) => {
  var _lessonPayload$slides, _lessonPayload$transc;
  const {
    isTablet,
    isMobile
  } = useMediaQuery();
  const lessonPayload = isTracks ? lesson.toJS() : fullLesson;
  const content = useLessonContentById({
    lessonId: lessonPayload.id,
    contentId: Number(contentId),
    language: lessonPayload.language,
    fetchPolicy: trackId ? 'cache-only' : 'cache-first'
  });
  const onTabChange = event => UsageTracker.trackStandalone('Learning Center Interaction', {
    action: 'lesson-info-tab-clicked',
    tab: event.target.value
  });
  const handleOrganisationUrlClick = (professorId, organisation, organisationUrl) => () => UsageTracker.trackStandalone('Learning Center Interaction', {
    action: 'professor-organisation-click',
    contentType: 'LESSON',
    appearsIn: 'lessons',
    organisation,
    organisationUrl,
    professorId,
    lessonId: lessonPayload.id,
    contentId
  });
  const professorsById = {};
  if (!isTracks && lessonPayload.content) {
    lessonPayload.content.forEach(contentItem => {
      if (contentItem.professors) {
        contentItem.professors.forEach(professor => {
          professorsById[professor.id] = fromJS(professor);
        });
      }
    });
  }
  const professors = isTracks ? lesson.get('professors') || [] : Object.values(professorsById);
  return /*#__PURE__*/_jsx(View, {
    children: /*#__PURE__*/_jsxs(Tabs, {
      defaultSelected: "lesson-info",
      fill: true,
      inlineSize: isMobile ? '100%' : undefined,
      onSelectedChange: onTabChange,
      children: [/*#__PURE__*/_jsx(Tab, {
        padding: isTablet ? '250' : undefined,
        tabId: "lesson-info",
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.aboutThisLesson"
        }),
        children: /*#__PURE__*/_jsx(LessonOverview, {
          description: lessonPayload.description,
          hubId: content === null || content === void 0 ? void 0 : content.hubId,
          visibility: lessonPayload.visibility
        })
      }), professors.length > 0 && /*#__PURE__*/_jsx(Tab, {
        padding: isTablet ? '250' : undefined,
        tabId: "lesson-professors",
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.lessonInformation.professors",
          options: {
            count: professors.length
          }
        }),
        children: /*#__PURE__*/_jsx(ProfessorList, {
          handleOrganisationUrlClick: handleOrganisationUrlClick,
          i18nHeading: "learningCenter.lessonInformation.professors",
          professors: professors
        })
      }), /*#__PURE__*/_jsx(Tab, {
        padding: isTablet ? '250' : undefined,
        tabId: "resources",
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.resources.title"
        }),
        children: /*#__PURE__*/_jsx(ResourcesList, {
          additionalResources: lessonPayload.learningMaterials,
          i18nHeading: "learningCenter.lessonResources",
          i18nNoResources: "learningCenter.noLessonResources",
          onResourceClick: onResourceClick,
          slidesUrl: (_lessonPayload$slides = lessonPayload.slidesUrl) !== null && _lessonPayload$slides !== void 0 ? _lessonPayload$slides : undefined,
          transcriptUrl: (_lessonPayload$transc = lessonPayload.transcriptUrl) !== null && _lessonPayload$transc !== void 0 ? _lessonPayload$transc : undefined
        })
      })]
    })
  });
};
export default LessonInfoTabs;